/**
 * Who owns a node of the live tree, in Godot's sense: the root of the scene file that authored it.
 * Paths here are root-relative, as `belowRoot` gives them.
 */
import { SCENE_ROOT_PATH, relativeTo } from '../utils/nodePath';
/** The edited root with no `[editable]` heading. It owns the nodes of its own file. */
export const ROOT_OWNER = {
    level: 0,
    path: SCENE_ROOT_PATH,
    editablePaths: [],
    isEditable: true,
};
/**
 * The owner an instance at `path` becomes, with `editablePaths` its own file lists. Godot sets the
 * node's flag from any enclosing file that lists it (`packed_scene.cpp:691-695`), each path relative
 * to that file's root. `enclosing` holds the owners above the instance, outermost first.
 */
export function instanceOwner(enclosing, level, path, editablePaths) {
    const isEditable = enclosing.some((owner) => {
        const relative = owner.path === SCENE_ROOT_PATH ? path : relativeTo(owner.path, path);
        return relative !== undefined && owner.editablePaths.includes(relative);
    });
    return { level, path, editablePaths, isEditable };
}
function innermostOwnerOfLevel(owners, level) {
    for (let i = owners.length - 1; i >= 0; i--) {
        if (owners[i].level === level)
            return owners[i];
    }
    return undefined;
}
/**
 * Whether the edited root owns the node at `path`, or lists its owner as editable. `level` counts the
 * scenes that enclose the node's content. An instance's own root sits in its content's level, yet the
 * file that instanced it owns it. A level with no known owner reads as editable.
 */
export function isEditableNode(owners, level, path) {
    const own = innermostOwnerOfLevel(owners, level);
    const ownerLevel = own?.path === path ? level - 1 : level;
    return innermostOwnerOfLevel(owners, ownerLevel)?.isEditable ?? true;
}
//# sourceMappingURL=instanceOwners.js.map